// extracted by mini-css-extract-plugin
export var icon = "_44-1";
export var subtext = "_44-0";